<template lang="pug">
  .padding-container.single-user
    Notice.success(v-if="success == 'created'" :top="true") {{ $t('pages.create_user.success') }}
    Notice.success(v-if="success == 'updated'" :top="true") {{ $t('pages.single_user.success') }}
    Notice(v-if="success == 'error'" :top="true") {{ $t('pages.single_user.error') }}
      router-link(to="/users/view-users") {{ $t('pages.view_users.title') }}
    .details
      .padding
        .flex-grid
          loading(:active.sync="loading")
          div.account
            h4.b-margin-sm {{ $t('pages.create_user.titles.account') }}
            .input-group  
              label {{ $t('fields.email') }}*
              input(v-model="object.email" :placeholder="$t('fields.email')")
            .input-group  
              label {{ $t('fields.name') }}
              input(v-model="object.name" :placeholder="$t('fields.name')")
            .input-group  
              label {{ $t('fields.username') }}*
              input(v-model="object.username" :placeholder="$t('fields.username')")
            .input-group  
              label {{ $t('fields.password') }}*
              input(type="password" v-model="object.password" :placeholder="$t('fields.password')")
            .input-group  
              label {{ $t('fields.phone') }}
              input(v-model="object.business_phone" :placeholder="$t('fields.phone')")
          div.documents
            h4.b-margin-sm {{ $t('pages.create_user.titles.documents') }}
            .input-group
              label {{ $t('fields.document_select')}}
              DocumentBox(v-if="loading == false" v-bind:user="object.id")
    .details
      .padding
        .flex-grid
          div.address
            h4.b-margin-sm {{ $t('pages.create_user.titles.address') }}
            .input-group  
              label {{ $t('fields.name') }}
              input(v-model="object.business_name" :placeholder="$t('fields.name')")
            .input-group  
              label {{ $t('fields.phone') }}
              input(v-model="object.business_alt_phone" :placeholder="$t('fields.phone')")
            .input-group  
              label {{ $t('fields.employees') }}
              input(v-model="object.business_employees" type="number" :placeholder="$t('fields.employees')")
            .input-group  
              label {{ $t('fields.address1') }}
              input(v-model="object.business_address1" :placeholder="$t('fields.address1')")
            .input-group  
              label {{ $t('fields.address2') }}
              input(v-model="object.business_address2" :placeholder="$t('fields.address2')")
            .input-group  
              label {{ $t('fields.city') }}
              input(v-model="object.business_city" :placeholder="$t('fields.city')")
            .input-group  
              label {{ $t('fields.postcode') }}
              input(v-model="object.business_postcode" :placeholder="$t('fields.postcode')")
            .input-group  
              label {{ $t('fields.business_role') }}
              input(v-model="object.staff_role" :placeholder="$t('fields.business_role')")
          div.roles
            h4.b-margin-sm {{ $t('pages.create_user.titles.options') }}
            .input-group
              label {{ $t('fields.role')}}
              select.select(v-model="object.role")
                option(value="client") {{ $t('roles.client') }}
                option(value="admin") {{ $t('roles.admin') }}
            .input-group
              label {{ $t('fields.active')}}
              select.select(v-model="object.active")
                option(:value="true") True
                option(:value="false") False
            .input-group
              label {{ $t('fields.premium')}}
              select.select(v-model="object.premium")
                option(:value="false") {{ $t('tiers.0') }}
                option(:value="true") {{ $t('tiers.1') }}
            .input-group
              label {{ $t('fields.document_uploader')}}
              select.select(v-model="object.document_uploader")
                option(:value="true") True
                option(:value="false") False
    .flex-grid
      .col(@click="crudUpdate(object, service)")
        Button {{ $t('interface.save') }}
      .col(@click="$router.back(-1)")
        Button(type="secondary") {{ $t('interface.back') }}
    Notice(v-if="error") {{ error }}

</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import VoerroTagsInput from '@voerro/vue-tagsinput';
  import UserService from '@/services/user'
  import Notice from '@/components/Notice'
  import DocumentBox from '@/components/inputs/DocumentBox'

  // import GroupSelector from '@/components/inputs/GroupSelector'

  import Crud from '@/mixins/Crud'

  export default {
    data: function() {
      return {
        service: UserService,
        loading: true,
        success: '',
        error: '',
        data: [],
        user_id: 0,
        object: {
          email: '',
          company: '',
          username: '',
          password: '',
          name: '',
          role: '',
          staff_role: '',
          business_phone: '',
          business_employees: 1,
          document_uploader: '',
          business_alt_phone: '',
          business_address1: '',
          business_address2: '',
          business_city: '',
          business_postcode: '',
          premium: ''
        }
      }
    },
    methods: {
      async GET_SINGLE(page) {
        const id = this.$router.currentRoute.params.id;
        this.user_id = id;
        this.crudGet({ id: id }, UserService)
      },
      current_user_id() {
        return this.$store.getters.user.id
      },
      changed: function(e) {
        console.log('changed: single');
        console.log(e);
      }
    },
    created() {
      this.GET_SINGLE();
      this.$on('loading', function (e) {
        this.loading = e;
      })
      this.$on('error', function (e) {
        this.error = e;
        this.success = '';
      })
      this.$on('get', function (e) {
        const data = e.data;

        this.object = data;
        this.loading = false;
        this.error = '';
      })
      this.$on('updated', function (e) {
        if(e.data == true) {
          this.success = "updated"
        } else {
          this.success = "error"
        }
        this.error = '';
        this.loading = false;
        
        this.groups_selected = [];
        this.GET_SINGLE();
      })
    },
    components: { 
      "tags-input": VoerroTagsInput, 
      DocumentBox,
      Loading,
      Notice
    }
  }
</script>

<style lang="scss" scoped>
  .single-user {
    .details {
      border-radius: 5px;
      background:#3d576c;
      margin-bottom:15px;
      max-width:1200px;
      .padding {
        padding:25px;
        h4,label {
          color:#eee;
        }
        h4 {
          border-left:4px solid #eee;
          line-height:45px;
          text-indent:15px;
          font-size:20px;
        }
      }
    }
  }
</style>